module.exports = __webpack_public_path__ + "static/cocreate_img-6a67affd486d637ac11fa4c413c1d06a.png";